export const projects = [
  {
    photo: "/assets/project/exchange.png",
    title: "Trading View",
    description:
      "A crypto market and charting application that visualizes real-time price data using Binance API endpoints. Built with ReactJS, Redux Toolkit, and Tailwind CSS.",
    github_url: null,
    deploy_url: "https://trading-view-diy.netlify.app/",
  },
  {
    photo: "/assets/project/cryptoloan.png",
    title: "Crypto Loan",
    description:
      "A crypto-backed lending application that allows users to use their digital assets as collateral to request, manage, and repay loans. Built with Expo, React Native, Redux Toolkit, NativeWind, and secure authentication tools.",
    github_url: null,
    deploy_url: null,
  },
  {
    photo: "/assets/project/ropang.png",
    title: "ropangfi",
    description:
      "A Web3 launchpad and staking platform built on Solana, enabling users to create tokens, manage launchpads, and stake assets. Developed with React, Solana Web3, React Query, Zustand, and Hero UI.",
    github_url: null,
    deploy_url: null,
  },
  {
    photo: "/assets/project/funnyfun.png",
    title: "FunnyFun",
    description:
      "A PumpFun-style token creation and trading platform supporting Solana and EVM chains. Built with React, Redux Toolkit, Solana Web3, Wagmi, RainbowKit, and Tailwind CSS.",
    github_url: null,
    deploy_url: null,
  },
  {
    photo: "/assets/project/pockidex.png",
    title: "Pockidex",
    description:
      "A decentralized exchange (DEX) featuring token swap, liquidity pools, farming, staking, and token locking. Built with Next.js, Ethers.js, PancakeSwap libraries, Redux Toolkit, and Tailwind CSS.",
    github_url: null,
    deploy_url: null,
  },
  {
    photo: "/assets/project/queen.png",
    title: "Queen Exchange",
    description:
      "A cryptocurrency exchange platform offering real-time trading, advanced charting, deposits, and withdrawals. Built with Vue 2, Vuex, Ant Design Vue, and Klinecharts for a fast and seamless trading experience.",
    github_url: null,
    deploy_url: null,
  },
  {
    photo: "/assets/project/digikoin.png",
    title: "Digikoin Exchange",
    description:
      "A cryptocurrency exchange platform supporting real-time trading, market charting, deposits, and withdrawals. Built with React, Redux Saga, Web3 integration, and Bootstrap.",
    github_url: null,
    deploy_url: null,
  },
];

export const skills = [
  {
    name: "HTML",
    url: "/assets/skills/html.png",
  },
  {
    name: "CSS",
    url: "/assets/skills/css.png",
  },
  {
    name: "Tailwind",
    url: "/assets/skills/tailwindcss.png",
  },
  {
    name: "Hero UI",
    url: "/assets/skills/heroui.png",
  },
  {
    name: "Framer Motion",
    url: "/assets/skills/framer.png",
  },
  {
    name: "JavaScript",
    url: "/assets/skills/js.png",
  },
  {
    name: "TypeScript",
    url: "/assets/skills/ts.png",
  },
  {
    name: "React",
    url: "/assets/skills/react.png",
  },
  {
    name: "Expo",
    url: "/assets/skills/expo.png",
  },
  {
    name: "NextJS",
    url: "/assets/skills/next.png",
  },
  {
    name: "Vue",
    url: "/assets/skills/vue.png",
  },
  {
    name: "Redux",
    url: "/assets/skills/redux.png",
  },
  {
    name: "React Query",
    url: "/assets/skills/reactquery.png",
  },
  {
    name: "Axios",
    url: "/assets/skills/axios.png",
  },
  {
    name: "Postman",
    url: "/assets/skills/postman.png",
  },
  {
    name: "Github",
    url: "/assets/skills/github.png",
  },
  {
    name: "Git",
    url: "/assets/skills/git.png",
  },
  {
    name: "EVM",
    url: "/assets/skills/evm.png",
  },
  {
    name: "Solana",
    url: "/assets/skills/solana.png",
  },
  {
    name: "Wallet Connect",
    url: "/assets/skills/walletconnect.png",
  },
];
